import React, { useState } from 'react';

interface MediaFile {
  id: string;
  file: File;
  type: 'foto' | 'video';
  preview: string;
  name: string;
  size: number;
  isPrincipal?: boolean;
}

const TestAddProperty: React.FC = () => {
  const [mediaFiles, setMediaFiles] = useState<MediaFile[]>([]);
  const [selectedPrincipalImage, setSelectedPrincipalImage] = useState<string | null>(null);

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    Array.from(files).forEach((file) => {
      const isImage = file.type.startsWith('image/');
      const isVideo = file.type.startsWith('video/');
      
      if (!isImage && !isVideo) {
        alert('Apenas imagens e vídeos são permitidos');
        return;
      }

      const mediaFile: MediaFile = {
        id: Math.random().toString(36).substr(2, 9),
        file,
        type: isImage ? 'foto' : 'video',
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
        isPrincipal: false
      };

      setMediaFiles(prev => [...prev, mediaFile]);
    });
  };

  const selectPrincipalImage = (id: string) => {
    setSelectedPrincipalImage(id);
    setMediaFiles(prev => prev.map(file => ({
      ...file,
      isPrincipal: file.id === id
    })));
    alert('Imagem principal selecionada!');
  };

  const fotos = mediaFiles.filter(file => file.type === 'foto');

  return (
    <div style={{ padding: '20px', backgroundColor: '#1f2937', color: 'white', minHeight: '100vh' }}>
      <h1>Teste - Seleção de Imagem Principal</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <input
          type="file"
          multiple
          accept="image/*,video/*"
          onChange={handleFileUpload}
        />
      </div>

      {mediaFiles.length > 0 && (
        <div>
          <h2>Mídias selecionadas ({mediaFiles.length})</h2>
          
          {/* Debug Info */}
          <div style={{ 
            backgroundColor: '#fbbf24', 
            color: '#92400e', 
            padding: '10px', 
            marginBottom: '10px',
            borderRadius: '5px'
          }}>
            <p>DEBUG: Total de mídias: {mediaFiles.length}</p>
            <p>Fotos: {fotos.length}</p>
            <p>Vídeos: {mediaFiles.filter(f => f.type === 'video').length}</p>
            <p>Tipos: {mediaFiles.map(f => `${f.name}(${f.type})`).join(', ')}</p>
          </div>

          {/* Seleção de imagem principal */}
          {fotos.length > 0 && (
            <div style={{ 
              backgroundColor: '#4b5563', 
              padding: '15px', 
              marginBottom: '15px',
              borderRadius: '5px',
              border: '1px solid #6b7280'
            }}>
              <h3 style={{ marginBottom: '10px' }}>
                🖼️ Selecione a imagem principal (clique em uma foto):
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px' }}>
                {fotos.map((mediaFile) => (
                  <div 
                    key={mediaFile.id} 
                    style={{ 
                      cursor: 'pointer',
                      border: selectedPrincipalImage === mediaFile.id ? '2px solid #ef4444' : '2px solid #6b7280',
                      borderRadius: '5px',
                      overflow: 'hidden',
                      backgroundColor: selectedPrincipalImage === mediaFile.id ? '#fef2f2' : '#374151'
                    }}
                    onClick={() => selectPrincipalImage(mediaFile.id)}
                  >
                    <img
                      src={mediaFile.preview}
                      alt={mediaFile.name}
                      style={{ width: '100%', height: '80px', objectFit: 'cover' }}
                    />
                    {selectedPrincipalImage === mediaFile.id && (
                      <div style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        backgroundColor: '#ef4444',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>
                        ✓
                      </div>
                    )}
                    <div style={{ padding: '8px' }}>
                      <p style={{ fontSize: '12px', margin: '0', color: '#d1d5db' }}>{mediaFile.name}</p>
                      {selectedPrincipalImage === mediaFile.id && (
                        <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: '#f87171', fontWeight: 'bold' }}>
                          ✓ Selecionada
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {selectedPrincipalImage && (
                <div style={{ 
                  marginTop: '10px',
                  backgroundColor: '#dcfce7',
                  color: '#166534',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #bbf7d0'
                }}>
                  <p>✓ Imagem principal selecionada: {mediaFiles.find(f => f.id === selectedPrincipalImage)?.name}</p>
                </div>
              )}
            </div>
          )}

          {/* Todas as mídias */}
          <div>
            <h3>📁 Todas as mídias ({mediaFiles.length} arquivos):</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
              {mediaFiles.map((mediaFile) => (
                <div key={mediaFile.id} style={{ position: 'relative' }}>
                  <div style={{ 
                    aspectRatio: '1',
                    backgroundColor: '#4b5563',
                    borderRadius: '5px',
                    overflow: 'hidden',
                    border: '2px solid #6b7280'
                  }}>
                    {mediaFile.type === 'foto' ? (
                      <img
                        src={mediaFile.preview}
                        alt={mediaFile.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    ) : (
                      <video
                        src={mediaFile.preview}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        muted
                      />
                    )}
                  </div>
                  
                  {/* Badge de tipo */}
                  <div style={{
                    position: 'absolute',
                    top: '5px',
                    left: '5px',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '10px',
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}>
                    {mediaFile.type === 'foto' ? 'Foto' : 'Vídeo'}
                  </div>
                  
                  {/* Badge de imagem principal */}
                  {mediaFile.isPrincipal && (
                    <div style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      backgroundColor: '#ef4444',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '10px',
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}>
                      Principal
                    </div>
                  )}
                  
                  <div style={{ marginTop: '5px' }}>
                    <p style={{ fontSize: '12px', margin: '0', color: '#d1d5db' }}>{mediaFile.name}</p>
                    {mediaFile.isPrincipal && (
                      <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: '#f87171', fontWeight: 'bold' }}>
                        ✓ Imagem principal
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestAddProperty;
